import React, { ChangeEvent, useState } from "react";
import styles from "./footer.module.scss";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { apiRequest, authService, catchErrorMessageHandler, getUserName } from "../../../infrastructure/backendService";
import { useNavigate } from "react-router-dom";
import { isEmpty, isNil } from "lodash";
import { Box, IconButton } from "@mui/material";
import CONSTANTS from "../../../config/constants.json";
import toast, { Toaster } from "react-hot-toast";
import ToastSuccess from "../../common/toast/toastSuccess";
import ToastError from "../../common/toast/toastError";
import apiPath from "../../../config/apiPaths.json";
import LOCALE from '../../../config/en-us.json';
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Dialog, DialogTitle } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ArchiveIcon from '@mui/icons-material/Archive';
import Paper from '@mui/material/Paper';
import myProfileIcon from "../../../../public/images/myProfileIcon.svg"
import SuccessPopup from "../../devotee/donation/successPopup";
import ErrorPopup from "../../common/ErrorPopup";
import CommonDonationPopup from "../../home/CommonDonationPopup";
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import CloseIcon from "@mui/icons-material/Close";

const CustomInputField = styled(TextField)({
  "& input": {
    margin: "5px",
    height: "49px",
    color: "#882E14",
    fontWeight: "500",
    width: "100%",
  },
  "& .MuiInputBase-root": {
    height: "49px",
    width: "100%",
  },
  "& label.Mui-focused": {
    color: "#882E14",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#882E14",
    borderRadius: "20px",
    borderWidth: "2px",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      // borderRadius: "16px",
      height: "49px",
      border: "2px solid #882E14",
      borderBottomLeftRadius: "16px",
      borderTopLeftRadius: "16px",
      padding: 0,
      width: "100%",
    },
    "&:hover fieldset": {
      borderBottomLeftRadius: "16px",
      borderTopLeftRadius: "16px",
      height: "49px",
      border: "2px solid #882E14",
    },
    "&.Mui-focused fieldset": {
      borderBottomLeftRadius: "16px",
      borderTopLeftRadius: "16px",
      height: "49px",
      border: "2px solid #882E14",
    },
  },
});

export default function Footer() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const [subscribedresText, setsubscribedresText] = useState<string>("");
  const currentYear = new Date().getFullYear();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isWarningOpen, setIsWarningOpen] = useState<boolean>(false);

  const handleReadMoreClick = () => {
    navigate('/abouttemple')
  }

  const readMore = () => {
    return <span className={styles.readMore} onClick={handleReadMoreClick}>Read more...</span>;
  };
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

  const templeInfo = (): React.ReactElement => {
    return (
      <div className={styles.imageTempleInfoContainer}>
        <div className={styles.imageAndContent}>
          <img
            src="/images/footerTemple.svg"
            className={styles.imageContainer}
          />
          <div className={styles.templeInfo}>
            Hindu Community and Cultural Center was incorporated in 1977. The
            need for a place where Hindus can pray, study religion and have
            cultural programs was seen as necessary and it was in this mood the
            birth of this organization took place {readMore()}
          </div>
        </div>
      </div>
    );
  };

  const stayconnectComponent = () => {
    return (
      <div className={styles.StayContainer}>
        <Typography className={styles.stayConnected}>Stay Connected</Typography>
        <div className={styles.inputFieldContainer}>
          <Box sx={{ position: "relative" }}>
            <CustomInputField
              placeholder="Enter mail"
              id="custom-css-outlined-input"
              type="text"
              value={email}
              onChange={onChangeEmail}
              autoComplete="off"
            />
            <Button className={styles.button} onClick={subscribeOnclick}>
              Subscribe
            </Button>
          </Box>
        </div>
        {isEmpty(subscribedresText) ? (
          ""
        ) : (
          <div style={{ color: "red", fontSize: "12px", marginTop: "-10px", marginLeft: "10px" }}>
            {subscribedresText}
          </div>
        )}
        <div className={styles.socialMediaIconsContainer}>
          <div
            className={styles.mediaIcon}
            onClick={() =>
              onClickRedirect("https://www.facebook.com/Livermoretemple")
            }
          >
            <img src="/images/FaceBook.svg" className={styles.facebookIcon} />
          </div>
          <div
            className={styles.mediaIcon}
            onClick={() =>
              onClickRedirect(
                "https://twitter.com/i/flow/login?redirect_after_login=%2Flivermoretemple"
              )
            }
          >
            <img src="/images/Twitter.svg" className={styles.twitterIcon} />
          </div>
          <div
            className={styles.mediaIcon}
            onClick={() =>
              onClickRedirect("https://www.instagram.com/livermoretemple")
            }
          >
            <img src="/images/InstaGram.svg" className={styles.instagramIcon} />
          </div>
          <div
            className={styles.mediaIcon}
            onClick={() =>
              onClickRedirect("https://www.youtube.com/c/LivermoreTempletv")
            }
          >
            <img src="/images/Youtube.svg" className={styles.youtubeIcon} />
          </div>
          <div className={styles.siteMap}>Site Map</div>
        </div>
        <p className={styles.templecopyRight}>
          © {currentYear} Hindu Community and Cultural Center{" "}
        </p>
      </div>
    )
  }

  const appStoreContent = (icon: React.ReactNode): React.ReactElement => {
    return <div className={styles.innerButton}>{icon}</div>;
  };

  const onClickRedirect = (path: string) => {
    window.open(path, "_blank");
  };

  const storesButtons = (): React.ReactElement => {
    return (
      <div className={styles.storeButtons}>
        <button
          className={styles.StorebuttonApple}
          onClick={() =>
            onClickRedirect(
              "https://itunes.apple.com/us/app/livermore-temple/id1186574740?mt=8"
            )
          }
        >
          {appStoreContent(
            <img
              src="/images/App_store_logo.svg"
              className={styles.buttonIcon}
            />
          )}
        </button>
        <button
          className={styles.StorebuttonGoogle}
          onClick={() =>
            onClickRedirect(
              "https://play.google.com/store/apps/details?id=com.livermore.devotee"
            )
          }
        >
          {appStoreContent(<img src="/images/Googleplay.svg" />)}
        </button>
      </div>
    );
  };

  const socialMediaIcons = (): React.ReactElement => {
    return (
      <div className={styles.socialMediaIconsContainer}>
        <div
          className={styles.mediaIcon}
          onClick={() =>
            onClickRedirect("https://www.facebook.com/Livermoretemple")
          }
        >
          <img src="/images/FaceBook.svg" className={styles.facebookIcon} />
        </div>
        <div
          className={styles.mediaIcon}
          onClick={() =>
            onClickRedirect(
              "https://twitter.com/i/flow/login?redirect_after_login=%2Flivermoretemple"
            )
          }
        >
          <img src="/images/Twitter.svg" className={styles.twitterIcon} />
        </div>
        <div
          className={styles.mediaIcon}
          onClick={() =>
            onClickRedirect("https://www.instagram.com/livermoretemple")
          }
        >
          <img src="/images/InstaGram.svg" className={styles.instagramIcon} />
        </div>
        <div
          className={styles.mediaIcon}
          onClick={() =>
            onClickRedirect("https://www.youtube.com/c/LivermoreTempletv")
          }
        >
          <img src="/images/Youtube.svg" className={styles.youtubeIcon} />
        </div>
      </div>
    );
  };

  const leftContainer = (): React.ReactElement => {
    return (
      <div className={styles.leftSideContainer}>
        {templeInfo()}
      </div>
    );
  };

  const validateSubscribeText = (): boolean => {
    if (isEmpty(email)) {
      return true;
    } else {
      return false;
    }
  };

  const subscribeOnclick = (): void => {
    const currentDate = new Date().toISOString();

    if (email === '' || !email.includes('@') || !emailRegex.test(email)) {
      setsubscribedresText("Please Provide valid Email");
    } else if (email.length >= 100) {
      setsubscribedresText("Email Should be less than 100 characters");
    } else {
      apiRequest({
        method: "POST",
        endpoint: apiPath.subscribeMailingApi,
        params: {
          email: email,
        },
      })
        .then((res) => {
          setEmail("");
          // toast.custom(<ToastSuccess message={LOCALE.EMAIL_ALERT} />, {
          //   duration: 10000,
          // });
          toast.custom(<SuccessPopup headerMessage="Email" showMessage={LOCALE.EMAIL_ALERT} isOpen={isOpen} setIsOpen={setIsOpen} />,
            {
              duration: CONSTANTS.TOAST_POPUP_DURATION,
            });
          console.log(res, "res subs");
        })
        .catch((err) => {
          toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
            duration: CONSTANTS.TOAST_POPUP_DURATION,
          });
          console.log(err, "err");
        });
    }
  };

  const onChangeEmail = (e: ChangeEvent<HTMLInputElement>): void => {
    setEmail(e.target.value);
    setsubscribedresText("");
  };

  const stayConnected = () => {
    return (
      <div>
        <div>
          <div className={styles.templeAddress}>
            <h3>
              Hindu Community and Cultural Center
            </h3>
            <h4>
              Shiva-Vishnu Temple, Livermore, California
            </h4>
            <h5>A Non-Profit Organization since 1977</h5>
            <div>
            <h5>Tax ID# 94-2427126; Inc# D0821589</h5>
            </div>
            <h5>Phone: +1 (925) 449 6255</h5>
          </div>
        </div>
      </div>
    );
  };

  const rightContainer = () => {
    return (
      <div className={styles.rightContainer}>
        {stayConnected()}
        <div className={styles.emailContainer}>
          <div>Email: info@{CONSTANTS.DOMAIN_NAME}</div>
          {/* <div>{CONSTANTS.DOMAIN_NAME}</div> */}
        </div>
        {storesButtons()}
      </div>
    );
  };

  const handleMyProfileClick = () => {
    if (authService.isAuthenticated()) {
      // User is logged in, redirect to the logged-in donations page
      navigate(`/user/${getUserName()}`);
      // setOpen(false);
    } else {
      setIsWarningOpen(true);
    }
  }

  const handleReportsClick = () => {
    // navigate("/donations");
  }

  const handleDonateClick = () => {
    if (authService.isAuthenticated()) {
      // User is logged in, redirect to the logged-in donations page
      navigate("/donations");
      // setOpen(false);
    } else {
      setIsOpen(true);
    }
    // navigate("/donations");
  }

  const handleSponsorshipClick = () => {
    // navigate("/user/:userName");
  }

  const mobileViewFooter = () => {
    return (
      <div className={styles.mobileViewContainer}>
        <Paper sx={{ width: '100%', position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
          <BottomNavigation className={styles.iconMainContainer}>
            <div className={styles.iconsContainer}>
              <div className={styles.iconAndLabel} onClick={handleMyProfileClick}>
                <img className={styles.imageIcon} src="/images/myProfileIcon.svg" />
                <p style={{ color: "#fff",marginTop:"5px",marginBottom:"-6px" }}>MyProfile</p>
              </div>
              <div className={styles.iconAndLabel} style={{ opacity: "0.5" }} onClick={handleReportsClick}>
                <img className={styles.imageIcon} src="/images/reportsIcon.svg" />
                <p style={{ color: "#fff",marginTop:"5px",marginBottom:"-6px"  }}>Reports</p>
              </div>
              <div className={styles.iconAndLabel} onClick={handleDonateClick}>
                <img className={styles.imageIcon} src="/images/donateIcon.svg" />
                <p style={{ color: "#fff",marginTop:"5px",marginBottom:"-6px"  }}>Donate</p>
              </div>
              <div className={styles.iconAndLabel} style={{ opacity: "0.5" }} onClick={handleSponsorshipClick}>
                <img className={styles.imageIcon} src="/images/sponsorshipIcon.svg" />
                <p style={{ color: "#fff",marginTop:"5px",marginBottom:"-6px"  }}>Sponsorship</p>
              </div>
            </div>
          </BottomNavigation>
        </Paper>
      </div>
    )
  }

  const DonationPopupDialog = () => {
    return (
      <div className={styles.scrollbar}>
        <Dialog
          open={isOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xl"
          PaperProps={{
            style: {
              overflowY: "unset",
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
            },
          }}
        >
          <CommonDonationPopup isOpen={isOpen} setIsOpen={setIsOpen} />
        </Dialog>
      </div>
    );
  };

  const handleClose = (): void => {
    setIsOpen(false);
    setIsWarningOpen(false);
    toast.remove();
  };

  const LoginWarningPopupDialog = () => {
    return (
      <div className={styles.scrollbar}>
        <Dialog
          open={isWarningOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            style: {
              margin: "32px",
              borderRadius: "16px",
              background: "#FFF",
              maxHeight: "auto",
              maxWidth: "100%",
              width: "730px",
              flexDirection: "column",
            },
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "100%",
              backgroundColor: "#882E14",
              borderTopRightRadius: "16px",
              borderTopLeftRadius: "16px",
              height: "60px",
            }}
          >
            <DialogTitle sx={{ fontWeight: 700, fontSize: 28, color: "white" }}>
              Attention
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                float: "right",
                color: "#fff",
                padding: "20px",
                marginLeft: "auto",
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "30px",
            }}
          >
            <div style={{ backgroundColor: "#FEBE00", padding: "10px", height: "50px", width: "50px", borderRadius: "50%" }}>
              <WarningAmberOutlinedIcon sx={{
                color: "#fff",
                margin: "2px",
                alignItems: "center",
                fontSize: "40px",
                marginLeft: "5px"
              }} />
            </div>
            <Typography>Please Login!</Typography>
          </DialogContent>
        </Dialog>
      </div>
    );
  };

  return (
    <footer className={`${styles.footerContainer} no_print`}>
      {leftContainer()}
      {stayconnectComponent()}
      {rightContainer()}
      {isMobile ? mobileViewFooter() : ""}
      {isMobile ? DonationPopupDialog() : ""}
      {isMobile ? LoginWarningPopupDialog() : ""}
    </footer>
  );
}
